import { TableServerResponse } from 'types/TableServerResponse'

import { baseApi } from 'api/api'

import {
  DashboardAnalyticsPagination,
  DashboardAnalyticsFilter,
  RecentSale,
  ProfitableCategory,
  ProfitableEvent,
  InfoCards,
  ChartsFilter,
  ProxyTrafficResponse,
  ProfitChartResponse,
  PriceChartResponse,
} from './types'

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getInfoCards: build.query<InfoCards, { filters: DashboardAnalyticsFilter[] }>({
      query: (body) => ({
        url: '/api/dashboard/analytic-card',
        method: 'POST',
        data: body,
      }),
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' }],
    }),
    getRecentSales: build.query<TableServerResponse<RecentSale[]>, DashboardAnalyticsPagination>({
      query: (body) => ({
        url: '/api/dashboard/recent-sales',
        method: 'POST',
        data: body,
      }),
      transformResponse: (data: any) => {
        return {
          page: data.page,
          data: data.resentSales.map((item: any) => item),
        }
      },
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' },{ type: 'BookingsSales', id: 'BOOKING_SALE' }],
    }),
    getProfitableCategories: build.query<
      TableServerResponse<ProfitableCategory[]>,
      DashboardAnalyticsPagination
    >({
      query: (body) => ({
        url: '/api/dashboard/profitable-categories',
        method: 'POST',
        data: body,
      }),
      transformResponse: (data: any) => {
        return {
          page: data.page,
          data: data.profitableCategories.map((item: any, ind: number) => ({ ...item, id: ind })),
        }
      },
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' }],
    }),

    getProfitableEvents: build.query<
      TableServerResponse<ProfitableEvent[]>,
      DashboardAnalyticsPagination
    >({
      query: (body) => ({
        url: '/api/dashboard/profitable-events',
        method: 'POST',
        data: body,
      }),
      transformResponse: (data: any) => {
        return {
          page: data.page,
          data: data.profitableEvents.map((item: any, ind: number) => ({ ...item, id: ind })),
        }
      },
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' }],
    }),
    getPriceCharts: build.query<PriceChartResponse[], ChartsFilter>({
      query: (body) => ({
        url: '/api/dashboard/price-charts',
        method: 'POST',
        data: body,
      }),
      transformResponse: (data: any) => {
        return data?.chartData?.map((item: any, ind: number) => ({ ...item, id: ind }))
      },
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' }],
    }),
    getProfitCharts: build.query<ProfitChartResponse[], ChartsFilter>({
      query: (body) => ({
        url: '/api/dashboard/profit-charts',
        method: 'POST',
        data: body,
      }),
      transformResponse: (data: any) => {
        return data?.chartData?.map((item: any, ind: number) => ({ ...item, id: ind }))
      },
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' }],
    }),
    getProxyTrafficCharts: build.query<ProxyTrafficResponse[], void>({
      query: () => ({
        url: '/api/dashboard/proxy-traffic',
        method: 'GET',
      }),
      transformResponse: (data: any) => {
        return data?.proxies?.map((item: any) => ({ ...item }))
      },
      providesTags: () => [{ type: 'DashboardAnalytics', id: 'DASHBOARD_ANALYTICS' }],
    }),
  }),
})

export const {
  useGetInfoCardsQuery,
  useGetRecentSalesQuery,
  useGetProfitableCategoriesQuery,
  useGetProfitableEventsQuery,
  useGetPriceChartsQuery,
  useGetProfitChartsQuery,
  useGetProxyTrafficChartsQuery,
} = dashboardApi
